<template>
  <div style="overflow:hidden; height: 100%">

        <div class="lp-background-main">
            <div class="lp-row lp-background-overlay"></div>
        </div>

        <div class="lp-start-view">
            <!-- Header -->
            <div class="lp-header">
                <a class="navbar-brand" href="https://opensource.tencent.com">
                    <img src="static/images/logo_opensource_white.png" class="img-responsive" alt="Tencent open"/>
                </a>
            </div>
            <!-- Header -->
            <div class="row lp-premium lp-section">
                <div class="center-block" style="font-size:30px;font-weight:200;line-height:36px; margin-top:60px;">
                    <p>Tencent Contributor License Agreement</p>
                    <div style="width:120px; border-bottom:1px solid #fff; margin:30px auto"></div>
                    <button class="btn btn-md btn-primary" @click="logAdminIn" style="margin-top:60px; width:300px; height:50px; border-radius:2px; font-size: 20px; vertical-align:center">
                        <i class="fa fa-github" aria-hidden="true" style="font-size:30px; margin-right:15px"></i>&nbsp;Sign in with GitHub</button>
                </div>
            </div>
        </div> 
  </div>
</template>


<script>
import {getUserFromGithub} from '@/api/cla'
export default {
  created() {
    // this._getUserFromGithub()
  },
  methods: {
    logAdminIn() {
      window.location.href = "/auth/github"
    },
    _getUserFromGithub() {
      let data = {
        arg:{},
        fun:"get",
        obj:"users"
      }
      getUserFromGithub(data).then((res) =>{
        console.log(res)
      })
    }
  }
}

</script>
<style >

</style>


// WEBPACK FOOTER //
// src/javascript/login/components/login.vue